import {UserRole} from "./fixture/userRole";

export const fourDays = (targetDay: string): string[] => {
  const todayData = new Date(targetDay);
  const nowData = new Date(todayData.setDate(todayData.getDate()));
  const towDaysAgoData = new Date(todayData.setDate(todayData.getDate() - 1 ));
  const threeDaysAgoData = new Date(todayData.setDate(todayData.getDate() - 1 ));
  const fourDaysAgoData = new Date(todayData.setDate(todayData.getDate() - 1 ));
  return [
    nowData.toLocaleDateString(),
    towDaysAgoData.toLocaleDateString(),
    threeDaysAgoData.toLocaleDateString(),
    fourDaysAgoData.toLocaleDateString()
  ];
}

export const createId = (): string =>{
  const S =
    "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  const N = 8;
  return  Array.from(crypto.getRandomValues(new Uint32Array(N)))
    .map((n) => S[n % S.length])
    .join("");
}

export const formatDate = (date: Date): string => {
  return date.toDateString().replace(/-/g, '/').replace(/\/0/g, '/');
}

export const roleName = (role: UserRole): string => {
  if (role === UserRole.guest){
    return 'ゲスト';
  } else if (role === UserRole.general) {
    return '一般';
  } else if (role === UserRole.member) {
    return 'メンバー';
  } else if (role === UserRole.owner) {
    return 'チームオーナー';
  } else {
    return 'No Data';
  }
}
